/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlModification
 */
export interface ControlModification {
    /**
     * 
     * @type {string}
     * @memberof ControlModification
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlModification
     */
    parameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlModification
     */
    newParameterValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlModification
     */
    statementModification?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlModification
     */
    description?: string;
}

/**
 * Check if a given object implements the ControlModification interface.
 */
export function instanceOfControlModification(value: object): value is ControlModification {
    return true;
}

export function ControlModificationFromJSON(json: any): ControlModification {
    return ControlModificationFromJSONTyped(json, false);
}

export function ControlModificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlModification {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'parameterId': json['parameterId'] == null ? undefined : json['parameterId'],
        'newParameterValue': json['newParameterValue'] == null ? undefined : json['newParameterValue'],
        'statementModification': json['statementModification'] == null ? undefined : json['statementModification'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ControlModificationToJSON(json: any): ControlModification {
    return ControlModificationToJSONTyped(json, false);
}

export function ControlModificationToJSONTyped(value?: ControlModification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'parameterId': value['parameterId'],
        'newParameterValue': value['newParameterValue'],
        'statementModification': value['statementModification'],
        'description': value['description'],
    };
}

